import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Button from '../../Button';

class ModalConfirm extends Component {

  handleClick(e) {
    if (typeof this.props.button.onClick !== 'undefined') {
      this.props.button.onClick(e);
    }
  }

  handleCancelClick(e) {
    if (typeof this.props.cancel !== 'undefined') {
      if (typeof this.props.cancel.onClick === 'function') {
        this.props.cancel.onClick(e);
      } else {
        this.context.showModal(false);
      }
    } else {
      this.context.showModal(false);
    }
  }

  renderCancelText() {
    if (typeof this.props.cancel !== 'undefined') {
      return this.props.cancel.text || 'cancel';
    } else {
      return 'cancel';
    }
  }

  render() {
    return (
      <div className="modal-confirm">
        <i className="material-icons">error</i>
        <h4>{this.props.header}</h4>
        <p>{this.props.message}</p>
        <Button
          flat={true}
          onClick={this.handleClick.bind(this)}>
          {this.props.button.text}
        </Button>
        <Button
          flat={true}
          onClick={this.handleCancelClick.bind(this)}>
          { this.renderCancelText() }
        </Button>
      </div>
    );
  }
}

ModalConfirm.contextTypes = {
  showModal: PropTypes.func
};

export default ModalConfirm;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalConfirm/ModalConfirm.js